import { useState, useCallback } from 'react';
import type { EchartsGraphNodeContext } from '@atlassian/jira-assets-graphs-force-graph/src/common/types.tsx';
import { GRAPH_NODE_TYPES, type GraphNode } from '../../common/types.tsx';

export const useSelectedNode = (initialObjectId: string) => {
	const [selectedNode, setSelectedNode] = useState<GraphNode>({
		type: GRAPH_NODE_TYPES.OBJECT,
		nodeId: GRAPH_NODE_TYPES.OBJECT + initialObjectId,
		referenceId: initialObjectId,
	});

	const setSelectedObjectNode = useCallback((objectId: string) => {
		setSelectedNode({
			type: GRAPH_NODE_TYPES.OBJECT,
			nodeId: GRAPH_NODE_TYPES.OBJECT + objectId,
			referenceId: objectId,
		});
	}, []);

	const setSelectedObjectTypeNode = useCallback((node: EchartsGraphNodeContext) => {
		setSelectedNode({
			type: GRAPH_NODE_TYPES.OBJECT_TYPE,
			nodeId: GRAPH_NODE_TYPES.OBJECT_TYPE + node.id,
			referenceId: node.id,
			objectSchemaId: node.objectSchemaId ?? '',
			icon: node.icon,
			name: node.name,
		});
	}, []);

	return [selectedNode, { setSelectedObjectNode, setSelectedObjectTypeNode }] as const;
};
